import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GovernorateModel, LookupModel } from "libs/models/lookup-model";
import {
  getClientLookupService,
  getGovernorateLookupService,
  getInvoiceStatusLookupService,
  getPaymentMethodsLookupService,
  getRedemptionChannelsService,
} from "services/crosspay-service";
import { AsyncAppThunk } from "store/application-state";
import { showLoaderWhile } from "./ui";
import { RolesTypes } from "libs/models/login";

export interface LookupStore {
  governorates: GovernorateModel[];
  clients: LookupModel[];
  invoiceStatus: LookupModel[];
  paymentMethods: LookupModel[];
}

const initialState: LookupStore = {
  governorates: [],
  clients: [],
  invoiceStatus: [],
  paymentMethods: [],
};

const slice = createSlice({
  name: "lookups",
  initialState,
  reducers: {
    setGovernorates: (
      state: LookupStore,
      action: PayloadAction<GovernorateModel[]>
    ) => {
      state.governorates = action.payload;
    },
    setClients: (state: LookupStore, action: PayloadAction<LookupModel[]>) => {
      state.clients = action.payload;
    },
    setPaymentMethods: (
      state: LookupStore,
      action: PayloadAction<LookupModel[]>
    ) => {
      state.paymentMethods = action.payload;
    },
    setInvoiceStatus: (
      state: LookupStore,
      action: PayloadAction<LookupModel[]>
    ) => {
      state.invoiceStatus = action.payload;
    },
  },
});
export const {
  setGovernorates,
  setClients,
  setInvoiceStatus,
  setPaymentMethods,
} = slice.actions;
export const reducer = slice.reducer;

export const getGovernorate = (): AsyncAppThunk => async (dispatch, store) => {
  dispatch(
    showLoaderWhile(async () => {
      const response = await getGovernorateLookupService();
      if (response && response.result && response.result !== null) {
        dispatch(setGovernorates(response.result));
      }
    })
  );
};
export const getClientsLookup =
  (): AsyncAppThunk => async (dispatch, store) => {
    dispatch(
      showLoaderWhile(async () => {
        const response = await getClientLookupService();
        if (response && response.result && response.result !== null) {
          dispatch(setClients(response.result));
        }
      })
    );
  };
export const getInvoiceStatusLookup = (): AsyncAppThunk => async (dispatch) => {
  dispatch(
    showLoaderWhile(async () => {
      const response = await getInvoiceStatusLookupService();
      if (response && response.result && response.result !== null) {
        dispatch(setInvoiceStatus(response.result));
      }
    })
  );
};
export const getRedemptionsLookup = async (
  clientId?: string,
  role?: RolesTypes
) => {
  const queryOption =
    role === RolesTypes.SuperAdmin ? `?$filter=clientId eq ${clientId}` : "";
  const response = await getRedemptionChannelsService(queryOption);
  if (response && response.result && response.result !== null) {
    return response.result.list;
  }
  return [];
};

export const getPaymentMethods = (): AsyncAppThunk => async (dispatch, store) => {
  dispatch(
    showLoaderWhile(async () => {
      const response = await getPaymentMethodsLookupService();
      if (response && response.result && response.result !== null) {
        dispatch(setPaymentMethods(response.result));
      }
    })
  );
};
